import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import SearchIcon from "@mui/icons-material/Search";
import { ToastContainer } from "react-toastify";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import Wrapper from "../../components/UI/Wrapper";
import "../TiterForm/titer.css";
import { Alert } from "react-bootstrap";

const CheckHistory = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // const Relocation_Id = location.state?.Relocation_ID;
  const Relocation_Id = localStorage.getItem("lead_id_for_estimate");
  const baseAPI = process.env.REACT_APP_API_URL;

  const [historyData, setHistoryData] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchRows = async () => {
      try {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        const response = await axios.get(
          `${baseAPI}userget/GetCheckHistory?relocation_id=${Relocation_Id}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );

        if (response.data?.data?.length > 0) {
          setHistoryData(response.data.data);
          setError("");
        } else {
          setError("No history found.");
        }
      } catch (error) {
        setError("Error fetching data.");
      }
    };

    fetchRows();
  }, [Relocation_Id, baseAPI]);

  const handleViewDetails = (relocation_id, version_no) => {
    navigate("/CheckHistoryDetails", { state: { relocation_id, version_no } });
  };

  function formatDateWithTime(dateString) {
    if (!dateString) return "N/A";
    const dateObj = new Date(dateString);
    if (isNaN(dateObj)) return "Invalid date";
    const formatted = dateObj
      .toLocaleString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      })
      .replace(",", "");
    return formatted;
  }



  return (
    <>
      <div className="app-container-LeadList estimate-page-colSize">
        <MiniDrawer />

        {/* Main container shifted beside sidebar */}
        <div
          className="container-fluid container-viewLeadDetails"
          style={{
            padding: "6rem 1rem 1rem 1rem",
            transition: "all 0.3s ease-in-out",
          }}
        >
          <ToastContainer />

          {/* Header section */}
          <div className="country-header">
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                <b>Check History</b> | <HomeOutlinedIcon /> &gt;
                <span style={{ fontSize: "20px" }}> Check History</span>
              </h1>
            </div>
          </div>

          {/* Section title */}
          <Wrapper className="LeadDetails">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h3>Check History</h3>
              </div>
            </div>
          </Wrapper>
          <br></br>
          {/* Main table section */}
          <Wrapper
            className="LeadDetails"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              width: "100%",
              minHeight: "80vh",
              padding: "2rem 0",
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                width: "100%",
                background: "#fff",
                borderRadius: "10px",
                padding: "2rem",
              }}
            >
              {error && <p style={{ color: "red" }}>{error}</p>}

              {historyData.length > 0 ? (
                <div style={{ overflowX: "auto" }}>

                  <table
                    className="history-table"
                    border="1"
                    width="100%"
                    style={{
                      borderCollapse: "collapse",
                      textAlign: "center",
                      fontSize: "14px",
                      minWidth: "600px",
                    }}
                  >
                    <thead>
                      <tr style={{ backgroundColor: "#f8f9fa" }}>
                        <th>Lead ID</th>
                        <th>Amount exc.GST</th>
                        <th>GST</th>
                        <th>Discount</th>
                        <th>Payment Gateway Charges</th>
                        <th>Final Quotation</th>
                        <th>Archieved On</th>
                        <th style={{ textAlign: "center" }}>View</th>
                      </tr>
                    </thead>
                    <tbody>
                      {historyData.map((item, index) => (
                        <tr
                          key={index}
                          style={{
                            backgroundColor:
                              index % 2 === 0 ? "#ffffff" : "#f2f2f2",
                          }}
                        >
                          <td>
                            {item.relocation_id}_{item.version_no}
                          </td>
                          <td>
                            {item.amount_in_inr}
                          </td>
                          <td>
                            {item.total_gst}
                          </td>
                          <td>
                            {item.adjustment}
                          </td>
                          <td>
                            {item.paymentGatewayCharges}
                          </td>
                          <td><b>
                            {item.finalAfterGateway}/-</b>
                          </td>
                          <td>
                            {formatDateWithTime(item.archived_on)}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <button
                              onClick={() =>
                                handleViewDetails(
                                  item.relocation_id,
                                  item.version_no
                                )
                              }
                              style={{
                                height: "32px",
                                width: "40px",
                                backgroundColor: "#5B489D",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                            >
                              <SearchIcon
                                className="icon"
                                style={{ color: "white" }}
                              />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : !error ? (
                <p>Loading history...</p>
              ) : null}
            </div>
          </Wrapper>
        </div>
      </div>
    </>
  );
};

export default CheckHistory;
